import { apiAuth, apiResponseType } from "./index";

export interface PlaceSearchResult {
  name: string;
  address: string;
  latitude: number;
  longitude: number;
  place_id: string;
  rating: number | null;
  types: string[];
}

export interface PlaceSearchResponse {
  status: boolean;
  response: PlaceSearchResult[];
  message: string;
}

export const searchPlaces = async (address: string): Promise<apiResponseType> => {
  return apiAuth.get(`/maps/search-places`, {
    params: {
      address
    }
  });
};